export const baseUrl = "https://api.chekadice.com";
// export const baseUrl = "http://192.168.10.23:8001";
